module.exports = __webpack_public_path__ + "static/media/nerd_face.ee3e14a6.svg";